import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  useEditVideoMutation,
  useGetSingleVideoQuery,
} from "../../../features/Videos/videosApi";
import routes from "../../../config/routeConfig";
import Error from "../../ErrorMessage";
import VideoForm from "./VideoForm";

const initialState = {
  title: "",
  description: "",
  url: "",
  views: "",
  duration: "",
};

export default function EditVideoForm() {
  const navigate = useNavigate();
  const { videoId } = useParams();
  const [formValues, setFormValues] = useState(initialState);
  const {
    data: singleVideo,
    isLoading,
    isSuccess: isGetSingleVideoSuccess,
    isError: isGetSingleVideoFailed,
  } = useGetSingleVideoQuery(+videoId);
  const [
    editVideo,
    { isSuccess: isEditVideoSuccess, isError: isEditVideoFailed },
  ] = useEditVideoMutation();

  const handleSubmit = (e) => {
    e.preventDefault();
    const { title, description, url, views, duration } = formValues;
    editVideo({
      id: +videoId,
      title,
      description,
      url,
      views: `${views}k`,
      duration,
    });
  };

  useEffect(() => {
    if (isGetSingleVideoSuccess) {
      const { title, description, url, views, duration } = singleVideo;
      setFormValues({
        title,
        description,
        url,
        views: parseFloat(views.replace("K", "")),
        duration,
      });
    }
  }, [isGetSingleVideoSuccess, singleVideo]);

  useEffect(() => {
    if (isEditVideoSuccess) {
      setFormValues(initialState);
      navigate(routes.admin.videos);
    } else if (isEditVideoFailed) {
      alert("Edit video failed!");
    }
  }, [isEditVideoFailed, isEditVideoSuccess, navigate]);

  if (isLoading) return <div>Loading videos data...</div>;
  if (isGetSingleVideoFailed)
    return <Error error="Failed to load video data!" />;

  return (
    <VideoForm
      isForEdit={true}
      formValues={formValues}
      setFormValues={setFormValues}
      handleSubmit={handleSubmit}
    />
  );
}
